import useEventListener from "@/hooks/useEventListener";
import { useRef } from "react";

interface UseHoldClickProps {
	onHold: () => void;
}

function useHoldClick(props: UseHoldClickProps) {
	const elRef = useRef<HTMLDivElement | null>(null);
	const timeoutRef = useRef<number | null>(null);

	const handleMouseDown = () => {
		timeoutRef.current = window.setTimeout(() => {
			props.onHold();
		}, 500);
	};

	const handleMouseUp = () => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
	};

	useEventListener("mousedown", handleMouseDown, elRef);
	useEventListener("mouseup", handleMouseUp, elRef);
	useEventListener("mouseleave", handleMouseUp, elRef);

	return { elRef };
}

export default useHoldClick;
